<template>
  <div>
    <div class="semana" v-text="'Semana ' + semana"></div>
    <div class="dia" v-text="fechaEnPalabras"></div>
  </div>
</template>

<script>
// Moment
import moment from "moment";
import "moment/locale/es";

export default {
  data() {
    return {
      semana: moment().isoWeek(),
      fechaEnPalabras: moment(Date.now()).format("dddd DD [de] MMMM"),
    };
  },
  mounted() {
    moment.locale("es");
  },
};
</script>

<style>
.semana {
  font-weight: 700;
  font-size: 15px;
}

.dia {
  font-size: 11px;
  text-transform: capitalize;
}
</style>
